import Common from "../modules/common";

const templateProperties = {
  init: function () {
    this.switch();
    this.paginate();
  },

  switch: function () {
    $(".switch").on("click", function () {
      var btn = $(this);
      var disabled = JSON.parse(btn.attr("disable"));
      if (!disabled) {
        var page = $(".properties__body").data("page");
        btn.toggleClass("switch-active");
        // Filter
        templateProperties.filter(page);
      }
    });
  },

  filter: function (page) {
    var btn = $(".switch");
    var type = "";
    if (btn.hasClass("switch-active")) {
      type = btn.data("on");
    } else {
      type = btn.data("off");
    }

    $.ajax({
      url: ajaxurl,
      data: {
        action: "property_filter",
        deal: type,
        page: page,
      },
      type: "POST",
      dataType: "JSON",
      beforeSend: function () {
        btn.attr("disable", true);
        $(".properties__body").addClass("loading");
      },
      success: function (response) {
        btn.attr("disable", false);
        $(".properties__body").removeClass("loading");
        if (response.success) {
          $(".properties__items").html(response.data.items);
          $(".properties__pager").html(response.data.pager);

          Common.lazyLoadInstance.update();
        } else {
        }
      },
    });
  },

  paginate: function () {
    $("body").on("click", ".page-numbers", function (e) {
      e.preventDefault();
      var page = $(".properties__body").data("page");

      var btn = $(this);

      switch (true) {
        case btn.hasClass("next"):
          page++;
          break;

        case btn.hasClass("prev"):
          page--;
          break;

        default:
          page = btn.text();
          break;
      }

      templateProperties.filter(page);
    });
  },
};

export default templateProperties;
